import Authenticated from 'src/components/Authenticated';
import { Navigate } from 'react-router-dom';

import BoxedSidebarLayout from 'src/layouts/BoxedSidebarLayout';
import DocsLayout from 'src/layouts/DocsLayout';
import BaseLayout from 'src/layouts/BaseLayout';
import AccentHeaderLayout from 'src/layouts/AccentHeaderLayout';
import AccentSidebarLayout from 'src/layouts/AccentSidebarLayout';
import ExtendedSidebarLayout from 'src/layouts/ExtendedSidebarLayout';
import CollapsedSidebarLayout from 'src/layouts/CollapsedSidebarLayout';
import BottomNavigationLayout from 'src/layouts/BottomNavigationLayout';
import TopNavigationLayout from 'src/layouts/TopNavigationLayout';
import BoxedNoSidebarLayout from '../layouts/BoxedNoSidebarLayout';

import dashboardsRoutes from './dashboards';
import blocksRoutes from './blocks';
import applicationsRoutes from './applications';
import managementRoutes from './management';
import systemRoutes from './system';
import integrationsRoutes from './integrations';
import documentationRoutes from './documentation';
import accountRoutes from './account';
import baseRoutes from './base';
import registrationRoutes from './registration';


const standardRoutes = [
  {
    path: 'dashboards',
    children: dashboardsRoutes
  },
  {
    path: 'blocks',
    children: blocksRoutes
  },
  {
    path: 'applications',
    children: applicationsRoutes
  },
  {
    path: 'management',
    children: managementRoutes
  },
  {
    path: 'system',
    children: systemRoutes
  },
  {
    path: '3rdparty',
    children: integrationsRoutes
  },
  {
    path: 'registration',
    children: registrationRoutes
  }
];

const router = [
  {
    path: 'account',
    children: accountRoutes
  },
  {
    path: '',
    element: <BaseLayout />,
    children: baseRoutes
  },

  {
    path: 'registration',
    element: (
      <Authenticated>
        <BoxedNoSidebarLayout />
      </Authenticated>
    ),
    children: registrationRoutes
  },

  {
    path: '3rdparty',
    element: (
      <Authenticated>
        <BaseLayout />
      </Authenticated>
    ),
    children: integrationsRoutes
  },

  // Documentation

  {
    path: 'docs',
    element: <DocsLayout />,
    children: documentationRoutes
  },

  // Boxed Sidebar Layout

  {
    path: 'boxed-sidebar',
    element: (
      <Authenticated>
        <BoxedSidebarLayout />
      </Authenticated>
    ),
    children: [
      {
        path: '',
        element: <Navigate to='dashboards' replace />
      },
      ...standardRoutes
    ]
  },

  // Accent Sidebar Layout

  {
    path: 'accent-sidebar',
    element: (
      <Authenticated>
        <AccentSidebarLayout />
      </Authenticated>
    ),
    children: [
      {
        path: '',
        element: <Navigate to='dashboards' replace />
      },
      ...standardRoutes
    ]
  },

  // Collapsed Sidebar Layout

  {
    path: 'collapsed-sidebar',
    element: (
      <Authenticated>
        <CollapsedSidebarLayout />
      </Authenticated>
    ),
    children: [
      {
        path: '',
        element: <Navigate to='dashboards' replace />
      },
      ...standardRoutes
    ]
  },

  // Bottom Navigation Layout

  {
    path: 'bottom-navigation',
    element: (
      <Authenticated>
        <BottomNavigationLayout />
      </Authenticated>
    ),
    children: [
      {
        path: '',
        element: <Navigate to='dashboards' replace />
      },
      ...standardRoutes
    ]
  },

  // Top Navigation Layout

  {
    path: 'top-navigation',
    element: (
      <Authenticated>
        <TopNavigationLayout />
      </Authenticated>
    ),
    children: [
      {
        path: '',
        element: <Navigate to='dashboards' replace />
      },
      ...standardRoutes
    ]
  },

  // Accent Header Layout

  {
    path: 'accent-header',
    element: (
      <Authenticated>
        <AccentHeaderLayout />
      </Authenticated>
    ),
    children: [
      {
        path: '',
        element: <Navigate to='dashboards' replace />
      },
      ...standardRoutes
    ]
  },

  // Extended Sidebar Layout

  {
    path: 'extended-sidebar',
    element: (
      <Authenticated>
        <ExtendedSidebarLayout />
      </Authenticated>
    ),
    children: [
      ...standardRoutes
    ]
  }
];

export default router;
